import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/destination.css';

export default class Wayanad extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'overview'
    };
  }

  render() {
    const attractions = [
      {
        name: "Chembra Peak",
        image: "/assets/img/chembra-peak.png",
        description: "The highest peak in Wayanad at 2,100 meters, famous for the heart-shaped lake on top. A challenging trek offering breathtaking views of the Western Ghats.",
        highlight: "Highest Peak",
        bestTime: "Oct-Feb",
        duration: "4-5 Hours",
        tip: "Start early morning for the trek"
      },
      {
        name: "Edakkal Caves",
        image: "/assets/img/edakkal-caves.jpeg",
        description: "Ancient caves with prehistoric rock engravings dating back to the Neolithic age. The caves offer a fascinating glimpse into early human civilization.",
        highlight: "Prehistoric Art",
        bestTime: "Morning",
        duration: "2-3 Hours",
        tip: "Hire a guide for historical insights"
      },
      {
        name: "Soochipara Waterfalls",
        image: "/assets/img/soojipara.jpg",
        description: "A three-tiered waterfall also known as Sentinel Rock Waterfall. Perfect for swimming and surrounded by dense tropical forests.",
        highlight: "Three-Tiered Falls",
        bestTime: "Monsoon",
        duration: "2 Hours",
        tip: "Carry swimwear for a refreshing dip"
      },
      {
        name: "Banasura Sagar Dam",
        image: "/assets/img/banasura-dam.jpg",
        description: "The largest earth dam in India and the second largest in Asia. Boating facilities and stunning views of the Banasura Hills.",
        highlight: "Largest Earth Dam",
        bestTime: "Oct-Mar",
        duration: "2-3 Hours",
        tip: "Take a speed boat ride"
      },
      {
        name: "Wayanad Wildlife Sanctuary",
        image: "/assets/img/wayanad-wildlife-bg.jpg",
        description: "Part of the Nilgiri Biosphere Reserve, home to elephants, tigers, leopards, and over 200 species of birds.",
        highlight: "Wildlife Haven",
        bestTime: "Oct-May",
        duration: "3-4 Hours",
        tip: "Morning safaris offer best sightings"
      },
      {
        name: "Pookode Lake",
        image: "/assets/img/pookode-lake.jpg",
        description: "A natural freshwater lake shaped like India's map, surrounded by evergreen forests. Boating and freshwater aquarium are major attractions.",
        highlight: "Natural Lake",
        bestTime: "All Year",
        duration: "1-2 Hours",
        tip: "Try pedal boating"
      },
      {
        name: "Kuruva Island",
        image: "/assets/img/kuruva-island.jpg",
        description: "A protected river delta with evergreen forests, bamboo groves, and rare bird species. Accessible only by bamboo rafts.",
        highlight: "River Island",
        bestTime: "Oct-Mar",
        duration: "2-3 Hours",
        tip: "Take the bamboo raft ride"
      },
      {
        name: "Meenmutty Waterfalls",
        image: "/assets/img/meenmutty.jpg",
        description: "A spectacular 300-meter high waterfall, one of the largest in Wayanad. Requires a 2km trek through dense forest.",
        highlight: "Highest Waterfall",
        bestTime: "Monsoon",
        duration: "3-4 Hours",
        tip: "Wear sturdy trekking shoes"
      }
    ];

    const experiences = [
      {
        title: "Trekking Adventures",
        description: "Conquer the peaks of Chembra and other scenic trails",
        icon: "fas fa-hiking"
      },
      {
        title: "Wildlife Safaris",
        description: "Spot elephants, tigers, and exotic birds",
        icon: "fas fa-paw"
      },
      {
        title: "Tea Plantation Tours",
        description: "Walk through lush green tea estates",
        icon: "fas fa-leaf"
      },
      {
        title: "Camping",
        description: "Overnight camping under starlit skies",
        icon: "fas fa-campground"
      }
    ];

    const quickInfo = [
      { label: "Location", value: "Wayanad District, Kerala", icon: "fas fa-map-marker-alt" },
      { label: "Best Time to Visit", value: "October to February", icon: "fas fa-calendar-alt" },
      { label: "Nearest Airport", value: "Calicut International Airport (95 km)", icon: "fas fa-plane" },
      { label: "Nearest Railway", value: "Kozhikode Railway Station (110 km)", icon: "fas fa-train" },
      { label: "Famous For", value: "Tea Gardens, Waterfalls, Wildlife", icon: "fas fa-mountain" },
      { label: "Language", value: "Malayalam, English, Hindi", icon: "fas fa-language" }
    ];

    const trekkingSpots = [
      { name: "Chembra Peak", difficulty: "Moderate", distance: "9 km", duration: "4-5 hours" },
      { name: "Banasura Peak", difficulty: "Difficult", distance: "12 km", duration: "6-7 hours" },
      { name: "Brahmagiri Peak", difficulty: "Difficult", distance: "15 km", duration: "7-8 hours" },
      { name: "Neelimala Viewpoint", difficulty: "Easy", distance: "3 km", duration: "1-2 hours" }
    ];

    const wildlifeSpottings = [
      { name: "Indian Elephant", season: "All Year", probability: "High" },
      { name: "Bengal Tiger", season: "Oct-May", probability: "Medium" },
      { name: "Leopard", season: "All Year", probability: "Low" },
      { name: "Sloth Bear", season: "All Year", probability: "Medium" },
      { name: "Sambar Deer", season: "All Year", probability: "High" },
      { name: "Malabar Giant Squirrel", season: "All Year", probability: "High" }
    ];

    return (
      <div className="dest-destination-page">
        {/* Hero Section */}
        <div className="destination-hero">
          <div className="dest-hero-overlay"></div>
          <div className="dest-hero-background">
            <img src="/assets/img/wayanad-hero.png" alt="Wayanad Hills" />
          </div>
          <div className="dest-hero-content">
            <div className="dest-hero-badge">
              <span>Green Paradise of Kerala</span>
            </div>
            <h1 className="dest-hero-title">Wayanad</h1>
            <p className="dest-hero-subtitle">
              Where the Western Ghats weave magic with misty mountains and emerald valleys
            </p>
            <div className="dest-hero-location">
              <i className="fas fa-map-marker-alt"></i>
              <span>Wayanad District, Kerala, India</span>
            </div>
          </div>
          <div className="dest-hero-scroll">
            <span>Scroll to explore</span>
            <i className="fas fa-chevron-down"></i>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="dest-intro-section">
          <Grid>
            <Row>
              <Col xs={12} md={7} className="dest-intro-text">
                <h2 className="dest-section-title">Welcome to Wayanad</h2>
                <p className="dest-intro-description">
                  Wayanad, nestled in the Western Ghats, is a pristine hill station known for its 
                  lush green landscapes, rolling tea gardens, and majestic waterfalls. The name 
                  'Wayanad' means 'The Land of Paddy Fields', reflecting its agricultural heritage.
                </p>
                <p className="dest-intro-description">
                  This enchanting destination offers a perfect blend of adventure and tranquility. 
                  From trekking the highest peaks to exploring ancient caves with prehistoric 
                  carvings, Wayanad promises an unforgettable experience for nature lovers and 
                  adventure enthusiasts alike.
                </p>
                <div className="dest-highlight-box">
                  <i className="fas fa-star"></i>
                  <span>Did You Know? Wayanad is home to the Edakkal Caves, which contain rock carvings dating back over 8,000 years.</span>
                </div>
              </Col>
              <Col xs={12} md={5} className="dest-quick-info">
                <h3>Quick Facts</h3>
                <div className="dest-info-grid">
                  {quickInfo.map((info, index) => (
                    <div key={index} className="dest-info-card">
                      <div className="dest-info-icon">
                        <i className={info.icon}></i>
                      </div>
                      <div className="dest-info-content">
                        <span className="dest-info-label">{info.label}</span>
                        <span className="dest-info-value">{info.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Experiences Section */}
        <div className="dest-experiences-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title">Experiences in Wayanad</h2>
            <p className="dest-section-subtitle">
              Adventure awaits in the misty mountains
            </p>
          </div>
          <Grid>
            <Row className="experiences-grid">
              {experiences.map((exp, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="experience-col">
                  <div className="experience-card">
                    <div className="exp-icon">
                      <i className={exp.icon}></i>
                    </div>
                    <h4 className="exp-title">{exp.title}</h4>
                    <p className="exp-description">{exp.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Attractions Section */}
        <div className="dest-attractions-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title">Top Attractions in Wayanad</h2>
            <p className="dest-section-subtitle">
              Discover the enchanting beauty of the green paradise
            </p>
          </div>

          <Grid>
            <Row className="dest-attractions-grid">
              {attractions.map((attraction, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="dest-attraction-col">
                  <div className="dest-attraction-card">
                    <div className="dest-card-image">
                      <img src={attraction.image} alt={attraction.name} />
                      <div className="dest-card-overlay">
                        <span className="dest-highlight-tag">{attraction.highlight}</span>
                      </div>
                    </div>
                    <div className="dest-card-content">
                      <h3 className="dest-attraction-name">{attraction.name}</h3>
                      <p className="dest-attraction-description">{attraction.description}</p>
                      <div className="dest-card-footer">
                        <div className="dest-time-info">
                          <span className="dest-best-time">
                            <i className="far fa-calendar"></i>
                            {attraction.bestTime}
                          </span>
                          <span className="dest-duration">
                            <i className="far fa-clock"></i>
                            {attraction.duration}
                          </span>
                        </div>
                        <div className="dest-travel-tip">
                          <i className="fas fa-lightbulb"></i>
                          <span>{attraction.tip}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Chembra Peak Section */}
        <div className="chembra-section">
          <div className="chembra-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="chembra-content">
                <div className="chembra-badge">Trekker's Paradise</div>
                <h2 className="chembra-title">Chembra Peak</h2>
                <p className="chembra-description">
                  Standing tall at 2,100 meters, Chembra Peak is the highest peak in Wayanad and 
                  a trekker's delight. The trek to the summit takes you through lush tea estates, 
                  dense forests, and rolling grasslands.
                </p>
                <p className="chembra-description">
                  The highlight of the trek is the heart-shaped lake on the top, which never dries 
                  up. The panoramic views of the surrounding valleys and the Western Ghats from 
                  the peak are absolutely breathtaking.
                </p>
                <div className="chembra-tips">
                  <div className="tip">
                    <i className="fas fa-clock"></i>
                    <span>Start trek by 7:00 AM to avoid afternoon heat</span>
                  </div>
                  <div className="tip">
                    <i className="fas fa-water"></i>
                    <span>Carry sufficient water and energy snacks</span>
                  </div>
                  <div className="tip">
                    <i className="fas fa-book"></i>
                    <span>Permits required - available at forest office</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Edakkal Caves Section */}
        <div className="edakkal-section">
          <Grid>
            <Row>
              <Col xs={12} md={6} className="edakkal-content">
                <div className="edakkal-badge">Ancient History</div>
                <h2 className="edakkal-title">Edakkal Caves</h2>
                <p className="edakkal-description">
                  The Edakkal Caves are a fascinating archaeological site featuring prehistoric 
                  rock engravings dating back to the Neolithic age. The caves are actually two 
                  natural rock formations that form a shelter, with walls covered in ancient carvings.
                </p>
                <p className="edakkal-description">
                  The carvings depict human figures, animals, tools, and symbols that provide 
                  valuable insights into early human civilization. The trek to the caves through 
                  lush tea plantations adds to the adventure.
                </p>
                <div className="edakkal-features">
                  <div className="feature">
                    <i className="fas fa-calendar-alt"></i>
                    <span>8,000+ Years Old</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-mountain"></i>
                    <span>Rock Formations</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-history"></i>
                    <span>Neolithic Carvings</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Trekking Section */}
        <div className="trekking-section">
          <Grid>
            <div className="section-header">
              <h2 className="section-title-centered">Trekking Spots in Wayanad</h2>
              <p className="section-subtitle">
                Explore the best trails for adventure seekers
              </p>
            </div>
            <Row className="trekking-grid">
              {trekkingSpots.map((spot, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="trekking-col">
                  <div className="trekking-card">
                    <div className="trekking-icon">
                      <i className="fas fa-mountain"></i>
                    </div>
                    <h4 className="trekking-name">{spot.name}</h4>
                    <div className="trekking-details">
                      <span><strong>Difficulty:</strong> {spot.difficulty}</span>
                      <span><strong>Distance:</strong> {spot.distance}</span>
                      <span><strong>Duration:</strong> {spot.duration}</span>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Wildlife Section */}
        <div className="wildlife-section-wayanad">
          <div className="wildlife-overlay-wayanad"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="wildlife-content-wayanad">
                <div className="wildlife-badge-wayanad">Wildlife Sanctuary</div>
                <h2 className="wildlife-title-wayanad">Wayanad Wildlife Sanctuary</h2>
                <p className="wildlife-description-wayanad">
                  Part of the Nilgiri Biosphere Reserve, the Wayanad Wildlife Sanctuary is a 
                  haven for wildlife enthusiasts. The sanctuary is home to a diverse range of 
                  animals including elephants, tigers, leopards, and over 200 species of birds.
                </p>
                <p className="wildlife-description-wayanad">
                  The sanctuary is divided into four ranges - Muthanga, Tholpetty, Kurichiat, 
                  and Kidanganad. Jeep safaris are available from Muthanga and Tholpetty, 
                  offering excellent opportunities for wildlife viewing.
                </p>
                <div className="wildlife-stats-wayanad">
                  <div className="stat">
                    <span className="number">344</span>
                    <span className="label">Sq km Area</span>
                  </div>
                  <div className="stat">
                    <span className="number">200+</span>
                    <span className="label">Bird Species</span>
                  </div>
                  <div className="stat">
                    <span className="number">50+</span>
                    <span className="label">Mammal Species</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Wildlife Spottings Section */}
        <div className="wildlife-spottings-section">
          <Grid>
            <div className="section-header">
              <h2 className="section-title-centered">Wildlife You Can Spot</h2>
              <p className="section-subtitle">
                Keep your camera ready for these magnificent creatures
              </p>
            </div>
            <Row className="spottings-grid">
              {wildlifeSpottings.map((animal, index) => (
                <Col xs={12} sm={6} md={4} key={index} className="spottings-col">
                  <div className="spottings-card">
                    <div className="animal-icon">
                      <i className="fas fa-paw"></i>
                    </div>
                    <h4 className="animal-name">{animal.name}</h4>
                    <div className="animal-details">
                      <span><strong>Season:</strong> {animal.season}</span>
                      <span className={`probability ${animal.probability.toLowerCase()}`}>
                        <strong>Probability:</strong> {animal.probability}
                      </span>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Travel Tips Section */}
        <div className="dest-tips-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Travel Tips for Wayanad</h2>
              <p className="dest-section-subtitle">Make the most of your hill station getaway</p>
            </div>
            <Row className="dest-tips-grid">
              <Col xs={12} sm={6} md={3} className="tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <h4>Best Time to Visit</h4>
                  <p>October to February offers pleasant weather for sightseeing and trekking.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-tshirt"></i>
                  </div>
                  <h4>What to Pack</h4>
                  <p>Carry light woolens, comfortable trekking shoes, raincoat (during monsoon).</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-car"></i>
                  </div>
                  <h4>Getting Around</h4>
                  <p>Rent a private cab for convenient exploration of all attractions.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-utensils"></i>
                  </div>
                  <h4>Must Try</h4>
                  <p>Wayanadan tea, organic spices, and traditional Malabar cuisine.</p>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* CTA Section */}
        <div className="dest-cta-section">
          <div className="dest-cta-content">
            <h3>Escape to the Green Paradise</h3>
            <p>Let us help you plan your perfect Wayanad getaway</p>
            <Link to="/contact" className="dest-cta-button">
              Plan Your Trip
              <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}